export function within(pool, key) {
  const poolList = [].concat(pool || [])
  const keyList = [].concat(key || [])

  return keyList.every(key => poolList.indexOf(key) >= 0)
}

export function without(pool, remove) {
  const poolList = [].concat(pool || [])
  const removeList = [].concat(remove || [])

  const allowed = poolList.filter(key => removeList.indexOf(key) < 0)

  return allowed.length ? allowed : undefined
}



// WEBPACK FOOTER //
// ./src/selection.js